import { useIntl } from 'react-intl';
import { Button, Flex } from '@mantine/core';
import { ModuleView } from '@jadwalh/ui';
import { SectionContainer } from './styles';
import { ReactComponent as GM } from '../../../../../assets/images/svg/GM.svg';
import { useNavigate } from 'react-router-dom';

export default function GoogleMeet() {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  return (
    <SectionContainer>
      <ModuleView>
        <Flex
          direction={{ base: 'column' }}
          align={{ base: 'flex-start' }}
          className="detail_container"
        >
          <Flex justify="center" align="center" gap="10px">
            <GM style={{ width: '20px', height: '20px' }} />
            <p className="SemiBold title">Google Meet</p>
          </Flex>
          <Flex direction={'column'} gap={'16px'} w={'100%'} pt={'16px'}>
            <Flex
              direction={'column'}
              align={'space-between'}
              justify={'space-between'}
              className="info"
            >
              <p>
                {formatMessage({ id: 'integrations.googleMeet.description' })}
              </p>
              <p>{formatMessage({ id: 'integrations.googleMeet.benefits' })}</p>
              <Flex direction={'column'} gap={'0'}>
                <p style={{ marginBottom: '0' }}>
                  {formatMessage({
                    id: 'integrations.googleMeet.benefit1.title',
                  })}
                </p>
                <p>
                  {formatMessage({
                    id: 'integrations.googleMeet.benefit1.description',
                  })}
                </p>
              </Flex>
              <Flex direction={'column'} gap={'0'}>
                <p style={{ marginBottom: '0' }}>
                  {formatMessage({
                    id: 'integrations.googleMeet.benefit2.title',
                  })}
                </p>
                <p>
                  {formatMessage({
                    id: 'integrations.googleMeet.benefit2.description',
                  })}
                </p>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </ModuleView>
      <Button
        onClick={() => {
          navigate('/settings/calendar-sync');
        }}
      >
        {formatMessage({ id: 'activation' })}
      </Button>
    </SectionContainer>
  );
}
